var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading ? _c("loading-box") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c(
          "div",
          { staticClass: "grid-item" },
          [
            _c("datatable-filter", {
              ref: "filter",
              staticClass: "table-filter",
              class: _vm.filterPosition,
              on: {
                filter: function($event) {
                  return _vm.filter($event)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "grid-item" }, [
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", {
              ref: "table",
              staticClass: "dt-responsive display nowrap dataTable dtr-inline",
              class: (_vm.datatableClasses || []).concat(
                [_vm.loading ? "loading-results" : ""],
                [_vm.isCollapsed ? "collapsed" : ""]
              ),
              attrs: { id: _vm.elementId },
              nativeOn: {
                click: function($event) {
                  return _vm.tableClicked($event)
                }
              }
            })
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }